export default __webpack_public_path__ + "static/media/Stripe.46d9aa7b.svg";